import './silenceConsole'; // must be first, before modules that log on load
import { startErrorReporting } from './errorReporting';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { store } from './redux/store'

import global_en  from './translations/en.json';
import global_da  from './translations/da.json';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { Bounce, ToastContainer } from 'react-toastify';
import { startAnalytics } from './privacy/cookieChoice';
import { CookieConsent } from './privacy/CookieConsent';

// Self-hosted Umami (no cookies, no personal data), only after the visitor accepted statistics in the cookie popup
startAnalytics();

startErrorReporting({
  app: "player",
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  getToken: () => sessionStorage.getItem("BreefAccesstoken"),
});

i18next.init({
  interpolation: {escapeValue: false},
  lng: "da",
  resources: {
    en: {
      global: global_en
    },
    da: {
      global: global_da
    }
  }
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <Provider store={store}>
        <App />
        <CookieConsent />
        <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      </Provider>
    </I18nextProvider>
      
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
